import { z } from "zod/v4";

export const DeleteAgencyCustomerRequestPathParamSchema = z.object({
  id: z.uuid(),
});

export type DeleteAgencyCustomerRequestPathParamType = z.infer<
  typeof DeleteAgencyCustomerRequestPathParamSchema
>;

export const DeleteAgencyCustomerResponseBodySchema = z.string();

export type DeleteAgencyCustomerResponseBodyType = z.infer<
  typeof DeleteAgencyCustomerResponseBodySchema
>;
